<template>
  <div class="contact-com" :class="[ getTerminalForChrome() ? 'contact-mo': 'contact-pc']">
    <div class="layout">
      <div class="title">联系方式</div>
      <div class="image">
        <img src="../../assets/map.png" alt />
      </div>
      <div class="desc">
        <div class="left">
          <div>
            <span class="text1">电话</span>
            <span class="text2">：{{msg.phone}}</span>
          </div>
          <!--<div>
            <span class="text1">咨询QQ</span>
            <span class="text2">：{{msg.qq}}</span>
          </div>-->
          <div>
            <span class="text1">网址</span>
            <span class="text2">：{{msg.linkurl}}</span>
          </div>
          <div>
            <span class="text1">地址</span>
            <span class="text2">：{{msg.address}}</span>
          </div>
          <div style="margin-top: 30px">
            <span class="text2">
              <span class="text1">【交通指引】</span>
              {{msg.traffic}}
            </span>
          </div>
        </div>
        <div class="right">
          <img src="../../assets/qrcode.jpg" alt />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {findNewest} from '@/api/school'
export default {
  data() {
    return {
      msg: {}
    };
  },
  methods: {
    ...mapGetters(['getTerminalForChrome'])
  },
  mounted() {
    findNewest({}).then(res => {
      console.log('object', res)
      if (res.status === 200) {
        this.msg = res.data.data
      }
    })
  }
};
</script>

<style scoped lang="scss">
.contact-pc {
  width: 100%;
  display: flex;
  justify-content: center;
  .layout {
    width: 1136px;
    padding-top: 48px;
    .title {
      font-size: 20px;
      color: #31a087;
    }
    .image {
      width: 1136px;
      height: 397px;
      margin-top: 32px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .desc {
      margin-top: 46px;
      margin-bottom: 30px;
      display: flex;
      .left {
        margin-right: 26px;
        flex: 1;
        div {
          height: 30px;
          line-height: 30px;
        }
        font-size: 16px;
        .text1 {
          color: #31a087;
        }
        .text2 {
          color: #151515;
        }
      }
      .right {
        width: 165px;
        height: 206px;
        // background-color: #000;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
  }
}
.contact-mo {
  // padding: ;
  padding: 5.87vw 2.67vw 0vw 2.67vw;
  .layout {
    .title {
      font-size: 4.8vw;
      color: #31a087;
    }
    .image {
      // width: 96.67vw;
      // height: 43.47vw;
      img {
        width: 100%;
        // height: 100%;
        // object-fit: contain;
      }
    }
    .desc {
      margin-top: 6.4vw;
      overflow: hidden;
      .left {
        .text1 {
          font-size: 3.2vw;
          color: #31a087;
        }
        .text2 {
          font-size: 3.2vw;
        }
      }
      .right {
        width: 25.33vw;
        // text-align: center;
        // display: flex;
        // justify-content: flex-end;
        float: right;
        img {
          width: 100%;
        }
      }
    }
  }
}
</style>
